import { SET_CHOICE } from '../types';
export const setChoice = _ref => {
  let {
    currentChoice,
    exerciseId
  } = _ref;
  return {
    currentChoice,
    exerciseId,
    type: SET_CHOICE
  };
};